query NextMessage($contactId: ID!) {
    nextMessage(contactId: $contactId) {
        textBody
        htmlBody
        mjmlBody
        isNewsletter
        savedContentId
        runId
        stepId
        automationId
        subject
        scheduledAt
        attachments {
            id
            fileId
            name
            content
            contentType
            size
            url
            path
        }
    }
}

